import * as types from './constants'
/*eslint-disable*/
const initialState = {
	languages: [],
	defaultLanguage: {},
	selectedLanguage: {},
	selectedDefaultLanguage: {},
	languageId: 1,
	default: 0,
	name: null,
	data: {},
	hasChanges: false,
	overlayIsShowing: false,
	labelOverlayIsShowing: false,
	newLanguageName: null,
	newLabelKey: null,
	newLabelValue: null,
	selectedLabel: null,
	languageNameChanged: false,
	language: null,
	labelOverlayIsShowing: false,
}
const languageReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.SELECT_LANGUAGE:
			return {
				...state,
				selectedLanguage: action.selectedLanguage,
			}
		case types.SET_DEFAULT_LANGUAGE:
			return {
				...state,
				defaultLanguage: action.defaultLanguage,
			}
		case types.SET_LANGUAGE:
			return {
				...state,
				language: action.language,
			}
		case types.CHANGE_SELECTED_LANGAUGE_NAME:
			return {
				...state,
				selectedLanguage: {
					...state.selectedLanguage,
					name: action.name,
				},
			}

		case types.CHANGE_LANGUAGE_NAME_BUTTON:
			return {
				...state,
				languageNameChanged: action.languageNameChanged,
			}

		case types.SET_SELECT_LANGUAGES:
			return {
				...state,
				languages: action.languages,
			}

		case types.SET_DATA:
			return {
				...state,
				languageId: action.languageId,
				name: action.name,
				data: action.data,
				default: action.default,
			}

		case types.SET_DATA_VALUES:
			return {
				...state,
				data: {
					...state.data,
					[action.category]: action.changedData,
				},
			}
		case types.SET_CHANGED_DATA_VALUES:
			return {
				...state,
				changedData: action.changedData,
			}

		case types.SAVE_ALL:
			return {
				...state,
				data: action.data,
			}

		case types.HAS_CHANGES:
			return {
				...state,
				hasChanges: action.hasChanges,
			}

		case types.TOGGLE_OVERLAY:
			return {
				...state,
				overlayIsShowing: action.overlayIsShowing,
			}

		case types.TOGGLE_LABEL_OVERLAY:
			return {
				...state,
				labelOverlayIsShowing: action.labelOverlayIsShowing,
			}

		case types.SET_NEW_LANGUAGE:
			return {
				...state,
				newLanguageName: action.newLanguageName,
			}
		case types.SET_NEW_LABEL_KEY:
			return {
				...state,
				newLabelKey: action.newLabelKey,
			}
		case types.SET_NEW_LABEL_VALUE:
			return {
				...state,
				newLabelValue: action.newLabelValue,
			}

		case types.SELECT_DEFAULT_LANGUAGE:
			return {
				...state,
				selectedDefaultLanguage: action.selectedDefaultLanguage,
			}
		case types.SET_LABEL_CATEGORY:
			return {
				...state,
				selectedLabel: action.selectedLabel,
			}
		case types.SET_SYSTEM_DEFAULT_LANGUAGE:
			return {
				...state,
				systemDefaultLanguage: action.language,
			}

		default:
			return state
	}
}

export default languageReducer
